import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useSpaceFilterToggleStyles = makeStyles({
  root: {
    minWidth: 'auto',
    gap: tokens.spacingHorizontalXS,
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightRegular,
  },
});
